import React, { useState, useRef, useEffect } from 'react';
import { useStore } from '../context/StoreContext';
import { Icons } from './Icons';
import './AdminLock.css';

export default function AdminLock() {
  const { lockOpen, setLockOpen, adminPass, navigate } = useStore();
  const [passVal, setPassVal] = useState('');
  const [hasError, setHasError] = useState(false);
  const passRef = useRef(null);

  useEffect(() => {
    if (lockOpen && passRef.current) {
      setTimeout(() => passRef.current.focus(), 150);
    }
  }, [lockOpen]);

  const checkPass = () => {
    if (passVal === adminPass) {
      setLockOpen(false);
      navigate('admin');
      setPassVal('');
      setHasError(false);
    } else {
      setHasError(true);
      setPassVal('');
      setTimeout(() => setHasError(false), 450);
    }
  };

  if (!lockOpen) return null;

  return (
    <div className="admin-lock-overlay">
      <div className="admin-lock-box">
        <div className="lock-icon">{Icons.lock()}</div>
        <h2>Admin Panel</h2>
        <small>City Shopping Center · Dulha House</small>
        <input
          ref={passRef}
          type="password"
          className={`lock-input${hasError ? ' error' : ''}`}
          value={passVal}
          onChange={(e) => setPassVal(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && checkPass()}
          placeholder="Enter password"
        />
        {hasError && <div className="lock-error">Incorrect password. Try again.</div>}
        <button className="lock-submit-btn" onClick={checkPass}>Login</button>
        <button className="lock-back-btn" onClick={() => setLockOpen(false)}>← Back to Store</button>
      </div>
    </div>
  );
}
